import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../user-area-layout.service';

@Component({
  selector: 'mcb-portal-user-area-footer',
  template: '<div class="mcb-page-footer {{showSidebarClass}}"></div>'
})
export class PortalUserAreaFooterComponent implements OnInit {

  public showSidebarClass = '';
  constructor(private layoutService: LayoutService) { }

  ngOnInit() {
    this.layoutService.onSideBarToggle.subscribe(showSidebar => {
      if (!showSidebar) {
        this.showSidebarClass = 'mcb-sidebar-hide';
      } else {
        this.showSidebarClass = '';
      }
    });
  }
}
